import Grid from '@mui/material/Unstable_Grid2';
import { RELATION_MEMBER_OF } from '@backstage/catalog-model';
import {
  EntityUserProfileCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import {
  AboutUser,
  EntityLayout,
} from '@internal/plugin-medidata-catalog-react';
import { entityWarningContent } from './commonContent';

export const userPage = (
  <EntityLayout parentEntityRelations={[RELATION_MEMBER_OF]}>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={1}>
        {entityWarningContent}
        <Grid xs={12} md={6}>
          <EntityUserProfileCard showLinks />
        </Grid>
        <Grid xs={12} md={6}>
          <EntityOwnershipCard />
        </Grid>
        <Grid xs={12} md={6}>
          <AboutUser />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
